import { CarouselMode } from "@asosteam/asos-web-component-library-carousel";

const getCarouselMode = pageSize =>
  pageSize ? CarouselMode.pagination : CarouselMode.endlessSideScroll;

export default getCarouselMode;
